import { cva, type VariantProps } from 'class-variance-authority';
import { ReactNode } from 'react';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { Card } from '@/components/ui/card';
import { cn } from '@/utils/cn';

const dashboardCardVariants = cva(
    'bg-card shadow-card hover:shadow-card-hover transition-all duration-300 border-border rounded-lg border pt-4 pb-6 px-6',
    {
        variants: {
            size: {
                full: 'col-span-12',
                half: 'col-span-12 md:col-span-6',
                third: 'col-span-12 md:col-span-6 lg:col-span-4',
                twoThirds: 'col-span-12 md:col-span-12 lg:col-span-8',
                quarter: 'col-span-12 sm:col-span-6 lg:col-span-3',
            },
        },
        defaultVariants: {
            size: 'half',
        },
    },
);

interface DashboardCardProps extends VariantProps<typeof dashboardCardVariants> {
    title?: ReactNode;
    titleRight?: ReactNode;
    children: ReactNode;
    className?: string;
    onClick?: () => void;
}

export const DashboardCard = ({ title, titleRight, size, children, className, onClick }: DashboardCardProps) => {
    return (
        <Card className={cn(dashboardCardVariants({ size }), className)} onClick={onClick}>
            <ErrorBoundary>
                {(title || titleRight) && (
                    <div className="text-card-foreground mb-4 flex items-center justify-between pb-2">
                        {title && <h3 className="font-500 flex items-center gap-2 text-[21px]">{title}</h3>}
                        {titleRight && <div className="flex items-center">{titleRight}</div>}
                    </div>
                )}
                <div className="text-card-foreground">{children}</div>
            </ErrorBoundary>
        </Card>
    );
};
